import React, { createContext, useContext, useState } from "react";

interface StepContextType {
  currentStep: number;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  steps: string[];
  totalSteps: number;
}

const StepContext = createContext<StepContextType | undefined>(undefined);

export const StepProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const steps = ["Store Setting", "Hero Section", "Services", "Testimonials","About","Gallery", "Microsite","Footer"];
  const [currentStep, setCurrentStep] = useState<number>(0);
  const totalSteps = steps.length;

  return (
    <StepContext.Provider value={{ currentStep, setCurrentStep, steps, totalSteps }}>
      {children}
    </StepContext.Provider>
  );
};

export const useStep = (): StepContextType => {
  const context = useContext(StepContext);
  if (!context) throw new Error("useStep must be used within a StepProvider");
  return context;
};
